<template>
	<VInputMask
		ref="company-vat-input"
		:value="company.additionalAttributes.vat.value"
		:label="company.additionalAttributes.vat.name"
		layout="vertical"
		:tokens="{
        '#': { pattern: /\d/ },
      }"
		mask="GB############"
		masked
		:validate-method="GbUtils.validateVAT"
		:disabled="readOnly"
	/>
</template>

<script>

import GbUtils from "@/core/utils/regional/GbUtils";
import Company from "@/domains/Companies/Company.js";

export default {
	name:   'GBAdditionalAttributes',

	props: {
    company: {
      type:     Company,
      required: true
    },
		readOnly: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		return {
			GbUtils,
		}
	},
};
</script>
